import { Link } from 'react-router-dom'
import { useAuth } from '../../lib/auth'

export function FuncionarioDashboard() {
  const { user } = useAuth()

  return (
    <div>
      <h1 style={{ fontSize: 'var(--font-size-2xl)', fontWeight: 700, marginBottom: 'var(--space-2)' }}>
        Olá! 👋
      </h1>
      <p style={{ color: 'var(--color-gray-600)', marginBottom: 'var(--space-8)' }}>
        Bem-vindo(a) ao seu espaço de auto-atendimento.
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 'var(--space-4)' }}>
        <ActionCard
          icon="📋"
          title="Meu Espelho de Ponto"
          description="Visualize suas marcações e horas trabalhadas."
          to="/funcionario"
          note="Em breve"
          disabled
        />
        <ActionCard
          icon="📝"
          title="Minhas Solicitações (LGPD)"
          description="Solicite acesso, correção ou portabilidade dos seus dados."
          to="/funcionario/solicitacoes"
        />
      </div>

      {user && (
        <div className="card" style={{ marginTop: 'var(--space-8)', backgroundColor: 'var(--color-primary-light)' }}>
          <p style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-primary)' }}>
            <strong>Seus direitos LGPD:</strong> Você pode solicitar acesso, correção, eliminação ou
            portabilidade dos seus dados pessoais a qualquer momento pela aba "Minhas Solicitações".
          </p>
        </div>
      )}
    </div>
  )
}

function ActionCard({
  icon,
  title,
  description,
  to,
  note,
  disabled = false,
}: {
  icon: string
  title: string
  description: string
  to: string
  note?: string
  disabled?: boolean
}) {
  const inner = (
    <div
      className="card"
      style={{ cursor: disabled ? 'default' : 'pointer', opacity: disabled ? 0.6 : 1 }}
      onMouseEnter={(e) => { if (!disabled) (e.currentTarget as HTMLDivElement).style.boxShadow = 'var(--shadow-md)' }}
      onMouseLeave={(e) => { if (!disabled) (e.currentTarget as HTMLDivElement).style.boxShadow = 'var(--shadow-sm)' }}
    >
      <div style={{ fontSize: '2rem', marginBottom: 'var(--space-3)' }}>{icon}</div>
      <h2 style={{ fontSize: 'var(--font-size-base)', fontWeight: 600, marginBottom: 'var(--space-2)' }}>{title}</h2>
      <p style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-gray-600)' }}>{description}</p>
      {note && <span className="badge badge-gray" style={{ marginTop: 'var(--space-3)' }}>{note}</span>}
    </div>
  )

  if (disabled) return inner
  return <Link to={to} style={{ textDecoration: 'none' }}>{inner}</Link>
}
